import { gql } from '@apollo/client'
import {
  CourseOrderItem,
  CourseMethodType,
  OrderCustomerDetails
} from 'share/domain/course'
import { CasePlaceOrderUpdateFields } from 'share/domain/case'

export const PLACE_COURSE_ORDER = gql`
  mutation PLACE_COURSE_ORDER(
    $placeCourseOrder: PlaceCourseOrderRequestDtoInput!
  ) {
    orders {
      placeCourseOrder(courseOrder: $placeCourseOrder) {
        courseNumber
        orderId
        orderItemId
        isJoint
        providerId
        providerName
        courseType
        courseStatus
        courseMethod
        coursePaymentType
        coursePrice
        coursePhoneNumber
        courseAccessCode
        courseCompletionDate
        courseCertificationExpirationDate
        verifiedDetails
        verifiedCoDebtorDetails
        acceptedDisclosureAgreement
        shownCourseInstructions
        hasRegisteredCourse
      }
    }
  }
`

export interface PlaceCourseOrderVariables {
  placeCourseOrder: {
    caseId: number
    orderId: number
    orderItemId: number | null
    providerId: number
    courseMethodType: CourseMethodType
  }
}

export interface PlaceCourseOrderResponse {
  orders: {
    placeCourseOrder: CourseOrderItem[]
  }
}

export const UPDATE_ORDER_PRIMARY_APPLICANT_CUSTOMER_DETAILS = gql`
  mutation UPDATE_ORDER_PRIMARY_APPLICANT_CUSTOMER_DETAILS(
    $primaryDetails: UpdateOrderPrimaryApplicantCustomerDetailRequestDtoInput!
  ) {
    orders {
      updateOrderPrimaryApplicantCustomerDetails(request: $primaryDetails) {
        success
      }
    }
  }
`

export interface UpdateOrderPrimaryApplicantCustomerDetailsVariables {
  primaryDetails: OrderCustomerDetails
}

export interface UpdateOrderPrimaryApplicantCustomerDetailsResponse {
  orders: {
    updateOrderPrimaryApplicantCustomerDetails: {
      success: boolean
    }
  }
}

export const UPDATE_ORDER_VERIFIED_CUSTOMER_DETAILS_FLAG = gql`
  mutation UPDATE_ORDER_VERIFIED_CUSTOMER_DETAILS_FLAG(
    $request: UpdateOrderVerifiedDetailsFlagRequestDtoInput!
  ) {
    orders {
      updateOrderVerifiedCustomerDetailsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateOrderVerifiedCustomerDetailsFlagVariables {
  request: {
    caseId: number
    orderId: number
    flag: boolean
  }
}

export interface UpdateOrderVerifiedCustomerDetailsFlagResponse {
  orders: {
    updateOrderVerifiedCustomerDetailsFlag: {
      success: boolean
    }
  }
}

export const UPDATE_ORDER_CO_DEBTOR_CUSTOMER_DETAILS = gql`
  mutation UPDATE_ORDER_CO_DEBTOR_CUSTOMER_DETAILS(
    $coDebtorDetails: UpdateOrderCoDebtorCustomerDetailRequestDtoInput!
  ) {
    orders {
      updateOrderCoDebtorCustomerDetails(request: $coDebtorDetails) {
        success
      }
    }
  }
`

export interface UpdateOrderCoDebtorCustomerDetailsVariables {
  coDebtorDetails: OrderCustomerDetails
}

export interface UpdateOrderCoDebtorCustomerDetailsResponse {
  orders: {
    updateOrderCoDebtorCustomerDetails: {
      success: boolean
    }
  }
}

export const UPDATE_ORDER_CO_DEBTOR_VERIFIED_CUSTOMER_DETAILS_FLAG = gql`
  mutation UPDATE_ORDER_CO_DEBTOR_VERIFIED_CUSTOMER_DETAILS_FLAG(
    $request: UpdateOrderCoDebtorVerifiedDetailsFlagRequestDtoInput!
  ) {
    orders {
      updateOrderCoDebtorVerifiedCustomerDetailsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateOrderCoDebtorVerifiedCustomerDetailsFlagVariables {
  request: {
    caseId: number
    orderId: number
    flag: boolean
  }
}

export interface UpdateOrderCoDebtorVerifiedCustomerDetailsFlagResponse {
  orders: {
    updateOrderCoDebtorVerifiedCustomerDetailsFlag: {
      success: boolean
    }
  }
}

export const UPDATE_ORDER_ACCEPTED_DISCLOSURE_FLAG = gql`
  mutation UPDATE_ORDER_ACCEPTED_DISCLOSURE_FLAG(
    $request: UpdateOrderAcceptedDisclosureAgreementFlagRequestDtoInput!
  ) {
    orders {
      updateOrderAcceptedDisclosureAgreementFlag(request: $request) {
        success
      }
    }
  }
`
export interface UpdateOrderAcceptedDisclosureAgreementFlagVariables {
  request: {
    caseId: number
    courseType: number
    flag: boolean
    disclosureCourseOrderItemId: number
    disclosureVersion: number
  }
}

export interface UpdateOrderAcceptedDisclosureAgreementFlagResponse {
  orders: {
    updateOrderAcceptedDisclosureAgreementFlag: {
      success: boolean
    }
  }
}

export const UPDATE_ORDER_COURSE_INSTRUCTIONS_FLAG = gql`
  mutation UPDATE_ORDER_COURSE_INSTRUCTIONS_FLAG(
    $request: UpdateOrderShownCourseInstructionsFlagRequestDtoInput!
  ) {
    orders {
      updateOrderShownCourseInstructionsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateOrderShownCourseInstructionsFlagVariables {
  request: {
    caseId: number
    courseType: number
    flag: boolean
  }
}

export interface UpdateOrderShownCourseInstructionsFlagResponse {
  orders: {
    updateOrderShownCourseInstructionsFlag: {
      success: boolean
    }
  }
}

export const REGISTER_COURSE = gql`
  mutation REGISTER_COURSE($request: RegisterCourseRequestDtoInput!) {
    orders {
      registerCourse(request: $request) {
        success
        info1
        info2
        courseStatus
      }
    }
  }
`

export interface RegisterCourseVariables {
  request: {
    caseId: number
    registerCourseOrderItemId: number
  }
}

export interface RegisterCourseResponse {
  orders: {
    registerCourse: {
      success: boolean
      info1: string | null
      info2: string | null
      courseStatus: number
    }
  }
}

export const REGISTER_PHONE_COURSE = gql`
  mutation REGISTER_PHONE_COURSE(
    $request: RegisterPhoneCourseRequestDtoInput!
  ) {
    orders {
      registerPhoneCourse(request: $request) {
        success
        courseStatus
      }
    }
  }
`

export interface RegisterPhoneCourseVariables {
  request: {
    caseId: number
    registerCourseOrderItemId: number
  }
}

export interface RegisterPhoneCourseResponse {
  orders: {
    registerPhoneCourse: {
      success: boolean
      courseStatus: number
    }
  }
}

export const INCREMENT_ORDER_REGISTER_COURSE_COUNT = gql`
  mutation INCREMENT_ORDER_REGISTER_COURSE_COUNT(
    $request: IncrementOrderRegisterCourseRequestDtoInput!
  ) {
    orders {
      incrementOrderRegisterCourseCount(request: $request) {
        success
      }
    }
  }
`

export interface IncrementOrderRegisterCourseCountVariables {
  request: {
    caseId: number
    courseType: number
  }
}

export interface IncrementOrderRegisterCourseCountResponse {
  orders: {
    incrementOrderRegisterCourseCount: {
      success: boolean
    }
  }
}

export const PLACE_COURSE_ORDER_LOOKUP = gql`
  mutation PLACE_COURSE_ORDER_LOOKUP(
    $request: PlaceCourseOrderLookupRequestDtoInput!
  ) {
    orders {
      placeCourseOrderLookup(request: $request) {
        success
        errorMessage
        orderKeyFirstCourse
        orderKeySecondCourse
        firstCourseForJointCaseOrders
        secondCourseForJointCaseOrders
        hasPlacedFirstCourseOrder
        hasPlacedSecondCourseOrder
        firstCourseConsumerOrderId
        secondCourseConsumerOrderId
        hasPlacedFirstCourseOrderStatus
        hasPlacedSecondCourseOrderStatus
        hasPlacedFirstCourseOrderStatusMessage
        hasPlacedSecondCourseOrderStatusMessage
        firstCourseOrderStep
        secondCourseOrderStep
        organizationalUnitIdKey
        existingDudiUserIdKey
        orderItemSourceTypeId
        isDebtor1
      }
    }
  }
`
export interface PlaceCourseOrderLookupVariables {
  request: {
    caseId: number
    courseType: number
    lastName: string
    ssn: string
    isDebtor1: boolean
  }
}

export interface PlaceCourseOrderLookupResponseData {
  success: boolean
  errorMessage: string | null
  orderKeyFirstCourse: number | null
  orderKeySecondCourse: number | null
  firstCourseForJointCaseOrders: number | null
  secondCourseForJointCaseOrders: number | null
  hasPlacedFirstCourseOrder: boolean | null
  hasPlacedSecondCourseOrder: boolean | null
  firstCourseConsumerOrderId: number | null
  secondCourseConsumerOrderId: number | null
  hasPlacedFirstCourseOrderStatus: number | null
  hasPlacedSecondCourseOrderStatus: number | null
  hasPlacedFirstCourseOrderStatusMessage: string | null
  hasPlacedSecondCourseOrderStatusMessage: string | null
  firstCourseOrderStep: number | null
  secondCourseOrderStep: number | null
  organizationalUnitIdKey: number | null
  existingDudiUserIdKey: number | null
  orderItemSourceTypeId: number | null
  isDebtor1: boolean
}

export interface PlaceCourseOrderLookupResponse {
  orders: {
    placeCourseOrderLookup: PlaceCourseOrderLookupResponseData
  }
}

export const PLACE_NEW_COURSE_ORDER_CREATE_ACCOUNT = gql`
  mutation PLACE_NEW_COURSE_ORDER_CREATE_ACCOUNT(
    $request: ClientPortalAccountCreationRequestDtoInput!
  ) {
    orders {
      placeNewCourseOrderCreateAccount(request: $request) {
        success
        errorMessage
        hasPlacedFirstCourseOrder
        hasPlacedSecondCourseOrder
        hasPlacedFirstCourseOrderStatus
        hasPlacedSecondCourseOrderStatus
        firstCourseOrderStep
        secondCourseOrderStep
        isDebtor1
        orderItemSourceTypeId
      }
    }
  }
`

export interface PlaceNewCourseOrderCreateAccountVariables {
  request: {
    caseId: number
    courseType: number
    street: string
    city: string
    stateCode: string
    zipCode: string
    isDebtor1: boolean
  }
}

export interface PlaceNewCourseOrderCreateAccountResponseData {
  success: boolean
  errorMessage: string | null
  hasPlacedFirstCourseOrder: boolean | null
  hasPlacedSecondCourseOrder: boolean | null
  hasPlacedFirstCourseOrderStatus: number | null
  hasPlacedSecondCourseOrderStatus: number | null
  firstCourseOrderStep: number | null
  secondCourseOrderStep: number | null
  isDebtor1: boolean
  orderItemSourceTypeId: number | null
}

export interface PlaceNewCourseOrderCreateAccountResponse {
  orders: {
    placeNewCourseOrderCreateAccount: PlaceNewCourseOrderCreateAccountResponseData
  }
}

export const PLACE_NEW_COURSE_ORDER_ADD_SPOUSE_OR_JOINT_DEBTORS = gql`
  mutation PLACE_NEW_COURSE_ORDER_ADD_SPOUSE_OR_JOINT_DEBTORS(
    $request: ClientPortalCoApplicantCreationRequestDtoInput!
  ) {
    orders {
      placeNewCourseOrderAddSpouseOrJointDebtors(request: $request) {
        success
        errorMessage
        hasPlacedFirstCourseOrder
        hasPlacedSecondCourseOrder
        hasPlacedFirstCourseOrderStatus
        hasPlacedSecondCourseOrderStatus
        firstCourseOrderStep
        secondCourseOrderStep
        isDebtor1
        orderItemSourceTypeId
      }
    }
  }
`
export interface PlaceNewCourseOrderAddSpouseOrJointDebtorsVariables {
  request: {
    caseId: number
    courseType: number
    addSpouse: boolean
    firstName: string | null
    lastName: string | null
    ssn: string | null
    street: string | null
    city: string | null
    stateCode: string | null
    zipCode: string | null
    mobilePhoneNumber: string | null
    emailAddress: string | null
    isDebtor1: boolean
  }
}

export interface PlaceNewCourseOrderAddSpouseOrJointDebtorsResponseData {
  success: boolean
  errorMessage: string | null
  hasPlacedFirstCourseOrder: boolean | null
  hasPlacedSecondCourseOrder: boolean | null
  hasPlacedFirstCourseOrderStatus: number | null
  hasPlacedSecondCourseOrderStatus: number | null
  firstCourseOrderStep: number | null
  secondCourseOrderStep: number | null
  isDebtor1: boolean
  orderItemSourceTypeId: number | null
}

export interface PlaceNewCourseOrderAddSpouseOrJointDebtorsResponse {
  orders: {
    placeNewCourseOrderAddSpouseOrJointDebtors: PlaceNewCourseOrderAddSpouseOrJointDebtorsResponseData
  }
}

export const PLACE_NEW_ATTORNEY_AND_CONSUMER_COURSE_ORDER = gql`
  mutation PLACE_NEW_ATTORNEY_AND_CONSUMER_COURSE_ORDER(
    $request: PlaceNewAttorneyAndConsumerCourseOrderRequestDtoInput!
  ) {
    orders {
      placeNewAttorneyAndConsumerCourseOrder(request: $request) {
        success
        errorMessage
        firstCourseForJointCaseOrders
        secondCourseForJointCaseOrders
        orderKey
        orders {
          courseNumber
          orderId
          orderItemId
          isJoint
          providerId
          providerName
          courseType
          courseStatus
          courseMethod
          coursePaymentType
          coursePrice
          coursePhoneNumber
          courseAccessCode
          courseCompletionDate
          courseCertificationExpirationDate
          verifiedDetails
          verifiedCoDebtorDetails
          acceptedDisclosureAgreement
          shownCourseInstructions
          hasRegisteredCourse
        }
        updateCasePlaceOrderFields {
          hasPlacedFirstCourseOrder
          hasPlacedSecondCourseOrder
          hasPlacedFirstCourseOrderStatus
          hasPlacedSecondCourseOrderStatus
          hasPlacedFirstCourseOrderStatusMessage
          hasPlacedSecondCourseOrderStatusMessage
          firstCourseOrderStep
          secondCourseOrderStep
          isDebtor1
          orderItemSourceTypeId
        }
      }
    }
  }
`

export interface PlaceNewAttorneyAndConsumerCourseOrderVariables {
  request: {
    caseId: number
    courseType: number
    providerId: number
    courseMethodType: CourseMethodType
    isDebtor1: boolean
    isJoint: boolean
  }
}

export interface PlaceNewAttorneyAndConsumerCourseOrderResponseData {
  success: boolean
  errorMessage: string | null
  firstCourseForJointCaseOrders: number | null
  secondCourseForJointCaseOrders: number | null
  orderKey: number | null
  orders: CourseOrderItem[]
  updateCasePlaceOrderFields: CasePlaceOrderUpdateFields
}

export interface PlaceNewAttorneyAndConsumerCourseOrderResponse {
  orders: {
    placeNewAttorneyAndConsumerCourseOrder: PlaceNewAttorneyAndConsumerCourseOrderResponseData
  }
}

export const PLACE_NEW_COURSE_LOOKUP_FOUND_COURSE = gql`
  mutation PLACE_NEW_COURSE_LOOKUP_FOUND_COURSE(
    $request: PlaceNewCourseLookupFoundCourseRequestDtoInput!
  ) {
    orders {
      placeNewCourseLookupFoundCourse(request: $request) {
        success
        hasPlacedFirstCourseOrder
        hasPlacedSecondCourseOrder
        hasPlacedFirstCourseOrderStatus
        hasPlacedSecondCourseOrderStatus
        hasPlacedFirstCourseOrderStatusMessage
        hasPlacedSecondCourseOrderStatusMessage
        firstCourseOrderStep
        secondCourseOrderStep
        isDebtor1
        orderItemSourceTypeId
      }
    }
  }
`

export interface PlaceNewCourseLookupFoundCourseVariables {
  request: {
    caseId: number
    courseType: number
    isDebtor1: boolean
    orderItemSourceTypeId: number
    isJoint: boolean
  }
}

export interface PlaceNewCourseLookupFoundCourseResponse {
  orders: {
    placeNewCourseLookupFoundCourse: {
      success: boolean
      hasPlacedFirstCourseOrder: boolean | null
      hasPlacedSecondCourseOrder: boolean | null
      hasPlacedFirstCourseOrderStatus: number | null
      hasPlacedSecondCourseOrderStatus: number | null
      hasPlacedFirstCourseOrderStatusMessage: string | null
      hasPlacedSecondCourseOrderStatusMessage: string | null
      firstCourseOrderStep: number | null
      secondCourseOrderStep: number | null
      isDebtor1: boolean
      orderItemSourceTypeId: number | null
    }
  }
}
